"use client"

import { useState, useEffect } from "react"
import { jwtDecode } from "jwt-decode"
import { LI, P } from "../../../../AbstractElements"
import ProfileBox from "./ProfileBox"

interface DecodedToken {
  is_superuser: boolean
  email: string
  person?: {
    first_name: string
    last_name: string
  }
}

const UserProfile = () => {
  const [userInfo, setUserInfo] = useState({
    displayName: "Guest",
    role: "User",
    initials: "G",
  })

  useEffect(() => {
    try {
      const token = localStorage.getItem("accessToken")
      if (token) {
        const decoded: DecodedToken = jwtDecode(token)

        let displayName = "Guest"
        let role = "User"
        let initials = "G"

        if (decoded.is_superuser) {
          displayName = "Super User"
          role = "Super User"
         
          initials = "S" + "U"
        } else if (decoded.person) {
          displayName = decoded.person.first_name || "User"
          
          const firstName = decoded.person.first_name || ""
          const lastName = decoded.person.last_name || ""
          initials = (firstName.charAt(0) + lastName.charAt(0)).toUpperCase() || "U"
        }

        setUserInfo({ displayName, role, initials })
      }
    } catch (error) {
      console.warn("Failed to decode token for profile display", error)
      setUserInfo({
        displayName: "Guest",
        role: "User",
        initials: "G",
      })
    }
  }, [])

  return (
    <LI className="profile-nav onhover-dropdown">
      <div className="media profile-media">
        <div
          className="avatar-initials b-r-10"
          style={{
            width: "40px",
            height: "40px",
            backgroundColor: "#007bff",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            fontWeight: "bold",
            borderRadius: "10px",
          }}
        >
          {userInfo.initials}
        </div>
        <div className="media-body d-xxl-block d-none box-col-none">
          <div className="d-flex align-items-center gap-2">
            <span>{userInfo.displayName}</span>
            <i className="middle fa fa-angle-down"></i>
          </div>
          {/* <P className="mb-0 font-roboto">{userInfo.role}</P> */}
        </div>
      </div>
      <ProfileBox />
    </LI>
  )
}

export default UserProfile
